var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8001\\u8BB8-\\u5B9E\\u65F6\\u76D1\\u63A7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1007461-\\u5B9E\\u65F6\\u76D1\\u63A7-\\u8BA1\\u91CF\\u7535\\u8868",
    transform: "translate(-52.000000, -1191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-organization",
    transform: "translate(52.500000, 1191.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.2,
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "apartment-outlined",
    transform: "translate(2.000000, 1.750000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 12.5,
    height: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5317716,7.95723931 L10.1446397,7.95723931 L10.1446397,5.92989263 C10.1446397,5.87120628 10.0966236,5.82319017 10.0379372,5.82319017 L6.73016106,5.82319017 L6.73016106,4.54276069 L8.17064422,4.54276069 C8.28801692,4.54276069 8.38404914,4.44672848 8.38404914,4.32935578 L8.38404914,0.488067334 C8.38404914,0.370694632 8.28801692,0.274662421 8.17064422,0.274662421 L4.32935578,0.274662421 C4.21198308,0.274662421 4.11595086,0.370694632 4.11595086,0.488067334 L4.11595086,4.32935578 C4.11595086,4.44672848 4.21198308,4.54276069 4.32935578,4.54276069 L5.76983894,4.54276069 L5.76983894,5.82319017 L2.46206278,5.82319017 C2.40337643,5.82319017 2.35536033,5.87120628 2.35536033,5.92989263 L2.35536033,7.95723931 L0.96822839,7.95723931 C0.850855687,7.95723931 0.754823476,8.05327152 0.754823476,8.17064422 L0.754823476,12.0119327 C0.754823476,12.1293054 0.850855687,12.2253376 0.96822839,12.2253376 L4.80951683,12.2253376 C4.92688954,12.2253376 5.02292175,12.1293054 5.02292175,12.0119327 L5.02292175,8.17064422 C5.02292175,8.05327152 4.92688954,7.95723931 4.80951683,7.95723931 L3.31568244,7.95723931 L3.31568244,6.78351228 L9.18431756,6.78351228 L9.18431756,7.95723931 L7.69048317,7.95723931 C7.57311046,7.95723931 7.47707825,8.05327152 7.47707825,8.17064422 L7.47707825,12.0119327 C7.47707825,12.1293054 7.57311046,12.2253376 7.69048317,12.2253376 L11.5317716,12.2253376 C11.6491443,12.2253376 11.7451765,12.1293054 11.7451765,12.0119327 L11.7451765,8.17064422 C11.7451765,8.05327152 11.6491443,7.95723931 11.5317716,7.95723931 Z M4.00924841,8.97091265 L4.00924841,11.2116642 L1.76849682,11.2116642 L1.76849682,8.97091265 L4.00924841,8.97091265 Z M10.7315032,11.2116642 L8.49075159,11.2116642 L8.49075159,8.97091265 L10.7315032,8.97091265 L10.7315032,11.2116642 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.65,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.73035245,6.29596748 L10.1714098,6.29596748 C10.2888293,6.29596748 10.3848998,6.19989248 10.3848998,6.08246748 L10.3848998,2.23946748 C10.3848998,2.12204248 10.2888293,2.02596748 10.1714098,2.02596748 L6.32859021,2.02596748 C6.21117072,2.02596748 6.11510024,2.12204248 6.11510024,2.23946748 L6.11510024,6.08246748 C6.11510024,6.19989248 6.21117072,6.29596748 6.32859021,6.29596748 L7.76964755,6.29596748 L8.73035245,6.29596748 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#F7B500"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.d7434d6e7841f7534b8e923e0b180f4c.svg";
export { ForwardRef as ReactComponent };